// extracted by mini-css-extract-plugin
export default {"container":"kk2HurMR","header":"KRL3tCsZ","toolbar":"Plqc26dc","collapsed":"fXz0FH9H","expanded":"ZLq4CZ8B","divider":"jm6Zjsjf"};